import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 费用tab-运价表查询
export function queryEffectivePodCharge(data) {
  return request({
    url: URL.price.queryEffectivePodCharge,
    method: 'post',
    data
  })
}

// 查询拼箱目的港费用2
export function queryEffectivePodCharge2(data) {
  return request({
    url: URL.price.queryEffectivePodCharge2,
    method: 'post',
    data
  })
}

// 拼箱目的港收费输入-列表查询
export function queryPodCharges(data) {
  return request({
    url: URL.price.queryPodCharges,
    method: 'post',
    data
  })
}

// 拼箱目的港收费输入-保存
export function savePodCharge(data) {
  return request({
    url: URL.price.savePodCharge,
    method: 'post',
    data
  })
}
// 拼箱目的港收费输入-删除
export function deletePodCharges(data) {
  return request({
    url: URL.price.deletePodCharges,
    method: 'post',
    data
  })
}
// 拼箱目的港收费输入-审核
export function approvePodCharges(data) {
  return request({
    url: URL.price.approvePodCharges,
    method: 'post',
    data
  })
}
